<template>
  <div class="add-product" style="background-color: white; padding: 15px">
    <el-alert type="warning" show-icon :closable="false" style="margin: 10px 0" description="">
      <template #title>
        <!-- {{ $t("system.Config.367956-0", [smsprice]) }} -->
        {{ `${$t("system.xxtxTip")};${$t("system.yjsf")}` }}<span style="color: #ff2a6c">$0.01</span
        >{{ $t("system.yt") }};{{ $t("system.Config.367957-0") }}
      </template>
    </el-alert>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      v-loading="loading"
      height="66vh"
      :row-class-name="tableRowClassName"
      stripe
      size="small"
    >
      <el-table-column :label="$t('system.txyw')" align="center" width="200" :show-overflow-tooltip="true">
        <template #default="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('system.txdx')" align="center">
        <template #default="scope">
          <el-checkbox
            size="small"
            v-model="scope.row.self"
            true-label="1"
            false-label="0"
            @change="handlerMarkRowEdited(scope.row)"
            >{{ $t("system.acUser") }}</el-checkbox
          >
          <el-checkbox
            size="small"
            v-model="scope.row.repair"
            true-label="1"
            false-label="0"
            @change="handlerMarkRowEdited(scope.row)"
            >{{ $t("system.yyUser") }}</el-checkbox
          >
        </template>
      </el-table-column>
      <el-table-column :label="$t('system.txLock')" align="center" width="100">
        <template #default="scope">
          <el-switch
            @change="handlerLockChange($event, scope.row)"
            v-model="scope.row.enabled"
            active-value="1"
            inactive-value="0"
            active-color="#409EFF"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column :label="$t('system.sendType')" align="center">
        <template #default="scope">
          <el-checkbox
            size="small"
            v-model="scope.row.phone"
            true-label="1"
            false-label="0"
            @change="handlerMarkRowEdited(scope.row)"
            >{{ $t("system.sms") }}</el-checkbox
          >
          <el-checkbox
            size="small"
            v-model="scope.row.email"
            true-label="1"
            false-label="0"
            @change="handlerMarkRowEdited(scope.row)"
          >
            {{ scope.row.emailMoney ? $t("system.email") : $t("system.email") + $t("system.havepay") }}
          </el-checkbox>
        </template>
      </el-table-column>
      <el-table-column prop="name" :label="$t('system.txnrck')" align="center" width="160">
        <template #default="scope">
          <el-button size="mini" type="text" @click="handlerLookTips(1, scope.row.phoneText)">{{
            $t("system.sms")
          }}</el-button>
          <el-button size="mini" type="text" @click="handlerLookTips(2, scope.row.emailText)">{{
            $t("system.email")
          }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="name" :label="$t('system.cz')" fixed="right" align="center" width="300">
        <template #default="scope">
          <el-tooltip effect="dark" :content="$t('system.Config.978205-0')" placement="top">
            <el-button size="mini" type="text" icon="el-icon-edit-outline" @click="handlerExitOne(scope.row)">{{
              $t("system.bjyjtx")
            }}</el-button>
          </el-tooltip>
          <el-tooltip
            effect="dark"
            :content="editedRows.includes(scope.row.key) ? $t('system.Config.978205-1') : $t('system.Config.978205-2')"
            placement="top"
          >
            <el-button
              size="mini"
              :type="editedRows.includes(scope.row.key) ? 'warning' : 'text'"
              icon="el-icon-check"
              @click="handlerSaveSingle(scope.row, scope.$index)"
            >
              <span v-if="editedRows.includes(scope.row.key)">⚠️ {{ $t("system.save") }}</span>
              <span v-else>{{ $t("system.save") }}</span>
            </el-button>
          </el-tooltip>
          <el-tooltip effect="dark" :content="$t('system.Config.978205-3')" placement="top">
            <el-button size="mini" type="text" icon="el-icon-refresh-left" @click="handlerResetSingle(scope.$index)">{{
              $t("system.reset")
            }}</el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <!-- 查看提醒内容 -->
    <el-dialog :title="lookTips.title" :visible.sync="lookTips.dialogVisible" width="30%">
      <span v-html="lookTips.content"></span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="lookTips.dialogVisible = false">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" @click="lookTips.dialogVisible = false">{{ $t("common.definite") }}</el-button>
      </span>
    </el-dialog>
    <!-- 邮件编辑 -->
    <el-dialog :visible.sync="exitDialogVisible" width="1200px" :append-to-body="true">
      <div slot="title">
        <span style="font-size: 16px; font-weight: 500">{{ $t("system.yjbj") }}</span>
        <span style="margin-left: 10px; font-size: 13px; color: #909399; font-weight: normal">
          {{ $t("system.Config.978205-4") }}{{ $t("system.Config.978205-5") }}{{ $t("system.Config.978205-6")
          }}{{ $t("system.Config.978205-2") }}{{ $t("system.Config.978205-7") }}
        </span>
      </div>
      <el-form ref="form" :model="nowRow" label-width="110px">
        <el-form-item class="ca" :label="$t('system.wxtx')"
          >{{ $t("system.yjsf") }}$0.01{{ $t("system.yt") }}</el-form-item
        >
        <el-form-item :label="$t('system.txyw')">{{ nowRow.name }}</el-form-item>
        <el-form-item :label="$t('system.txdx2')">
          <el-checkbox v-model="nowRow.self" true-label="1" false-label="0">{{ $t("system.acUser") }}</el-checkbox>
          <el-checkbox v-model="nowRow.repair" true-label="1" false-label="0">{{ $t("system.yyUser") }}</el-checkbox>
        </el-form-item>
        <el-form-item :label="$t('system.yjbt')" required>
          <el-input style="max-width: 240px" v-model="nowRow.emailTitle" :placeholder="$t('system.pyjbt')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('system.yjnr')" required>
          <el-row style="margin-top: 40px; margin-left: -80px">
            <el-col :span="16">
              <el-tiptap ref="tiptapEditor" v-model="nowRow.emailText" :extensions="extensions" @onBlur="handlerBlur" />
            </el-col>
            <el-col :span="8">
              <el-card shadow="never" body-style="padding: 12px 12px;">
                <div slot="header" style="padding: 0 4px; font-size: 13px; color: #909399">
                  {{ $t("system.Config.978205-8") }}
                </div>
                <ul style="margin: 0; padding-left: 8px">
                  <li v-for="(item, index) in nowRow.variable" :key="index" style="line-height: 2">
                    <el-button
                      size="mini"
                      style="padding: 0"
                      type="text"
                      @click="handlerAddToPoint(item.key, item.value)"
                    >
                      【{{ item.value }}】
                    </el-button>
                  </li>
                </ul>
              </el-card>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <div style="text-align: left; flex: 1; color: #e6a23c; font-size: 13px">
          <i class="el-icon-warning"></i>
          {{ $t("system.Config.978205-9") }}{{ $t("system.Config.978205-5") }}{{ $t("system.Config.978205-10")
          }}{{ $t("system.Config.978205-2") }}{{ $t("system.Config.978205-11") }}
        </div>
        <el-button @click="exitDialogVisible = false">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" @click="handlerSaveEdit">{{ $t("common.definite") }}</el-button>
      </span>
    </el-dialog>
    <!-- 跳转钱包提示 -->
    <el-dialog
      :title="$t('common.tip')"
      :visible.sync="dialogToWallet"
      width="400px"
      :close-on-click-modal="false"
      @close="handlerCloseWallet"
    >
      <span class="el-icon-info" style="color: #eaa74d; font-size: 20px; margin-right: 4px"></span>
      <span>{{ $t("system.yebz") }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handlerCloseWallet">{{ $t("common.cancel") }}</el-button>
        <el-button size="small" type="primary" @click="handlerChangeToWallet"
          >{{ $t("common.definite") }}<span v-if="walletTime > 0">({{ walletTime }})</span></el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    // 需要的 extensions
    Doc,
    Text,
    Paragraph,
    Heading,
    Bold,
    Underline,
    Italic,
    Strike,
    ListItem,
    BulletList,
    OrderedList,
    Link,
    Image,
    CodeBlock,
    Blockquote,
    TodoItem,
    TodoList,
    TextAlign,
    FontSize,
    FontType,
    Fullscreen,
    TextHighlight,
    TextColor,
    FormatClear,
    Table,
    TableHeader,
    TableCell,
    TableRow,
    History,
    TrailingNode,
    HardBreak,
    HorizontalRule,
    LineHeight,
    Indent
  } from "element-tiptap";
  import { fileUploadImage } from "@/interface/upload";

  export default {
    name: "SystemConfig",
    data() {
      return {
        dialogToWallet: false,
        walletTime: 3,
        loading: false,
        setting: {},
        tableData: [],
        copyData: [],
        smsprice: "", //短信费用
        lookTips: {
          title: "",
          dialogVisible: false,
          content: ""
        },
        exitDialogVisible: false,
        nowRow: {},
        editingRowKey: "", // 记录正在编辑的行的key
        editedRows: [], // 记录已编辑但未保存的行的key
        extensions: [
          new Doc(), // 必须项
          new Text({
            length: 20
          }), // 必须项
          new Paragraph(), // 必须项
          new Heading({ level: 6 }), // 标题
          new Bold({ bubble: true }), // 加粗 bubble: true 在气泡菜单中渲染菜单按钮
          new Underline({ bubble: true, menubar: false }), // 下划线 bubble: true, menubar: false 在气泡菜单而不在菜单栏中渲染菜单按钮
          new Italic({ bubble: true }), // 斜体
          new Strike({ bubble: true }), // 删除线
          new ListItem(), // 使用列表必须项
          new BulletList({ bubble: true }), // 无序列表
          new OrderedList({ bubble: true }), // 有序列表
          new Link(), // 链接
          new Image({
            // 默认会把图片生成 base64 字符串和内容存储在一起，如果需要自定义图片上传
            // 自定义图片上传(默认会把图片生成base64字符串和内容存储到一起)
            // 图片的上传方法，返回一个 Promise<url>
            uploadRequest(file) {
              console.log("上传图片");
              // 自定义图片上传方式
              // 如果接口要求 Content-Type 是 multipart/form-data，则请求体必须使用 FormData
              const formdata = new FormData();
              //  image是后台接口需要参数名
              formdata.append("file", file);
              //  调用接口进行上传,拿到服务器返回的图片地址
              return fileUploadImage(formdata).then(res => {
                // 这个 return 是返回请求成功后拿到的url，赋值给富文本编辑器里面的img中的src属性
                return res.data;
              });
            }
          }), // 图片
          new CodeBlock({ bubble: true }), // 代码块
          new Blockquote(), // 引用
          new TodoItem(), // 任务列表必须项
          new TodoList(), // 任务列表
          new TextAlign({ bubble: true }), // 文本对齐方式
          new FontSize({ bubble: true }), // 字号
          new FontType({ bubble: true }), // 字体
          new Fullscreen(), // 全屏
          new TextHighlight({ bubble: true }), // 文本高亮
          new TextColor({ bubble: true }), // 文本颜色
          new FormatClear({ bubble: true }), // 清除格式
          new Table({ resizable: true }), // 表格
          new TableHeader(), // 表格必须项
          new TableCell(), // 表格必须项
          new TableRow(), // 表格必须项
          new History(), // 撤销
          new TrailingNode(), // 重做
          new HardBreak(), // 分割线
          new HorizontalRule(), // 行距
          new LineHeight(), // 增加缩进
          new Indent() // 减少缩进
        ],
        range: {
          end: 0,
          endText: null
        }
      };
    },
    mounted() {
      this.handlerGetInfo();
    },
    methods: {
      // 表格行样式
      tableRowClassName({ row }) {
        if (this.editedRows.includes(row.key)) {
          return "edited-row";
        }
        return "";
      },
      // 开关更改
      handlerLockChange(value, row) {
        let _self = this;
        if (value == 1 && row.emailMoney) {
          this.$confirm(_self.$t("system.payTip"), {
            confirmButtonText: _self.$t("common.definite"),
            cancelButtonText: _self.$t("common.cancel")
          })
            .then(() => {
              // 确认开启，标记为已编辑
              _self.handlerMarkRowEdited(row);
            })
            .catch(() => {
              row.enabled = "0";
            });
        } else {
          // 直接修改，标记为已编辑
          _self.handlerMarkRowEdited(row);
        }
      },
      // 标记行为已编辑状态（智能判断是否真的有改动）
      handlerMarkRowEdited(row) {
        // 找到对应的原始数据
        const originalIndex = this.tableData.findIndex(item => item.key === row.key);
        if (originalIndex === -1) return;

        const originalData = this.copyData[originalIndex];
        if (!originalData) return;

        // 比对关键字段是否有变化
        const hasChanges =
          row.enabled !== originalData.enabled ||
          row.self !== originalData.self ||
          row.repair !== originalData.repair ||
          row.phone !== originalData.phone ||
          row.email !== originalData.email ||
          row.emailTitle !== originalData.emailTitle ||
          row.emailText !== originalData.emailText ||
          row.phoneText !== originalData.phoneText;

        const editedIndex = this.editedRows.indexOf(row.key);

        if (hasChanges) {
          // 有变化，添加到已编辑列表
          if (editedIndex === -1) {
            this.editedRows.push(row.key);
          }
        } else {
          // 没有变化，从已编辑列表移除
          if (editedIndex > -1) {
            this.editedRows.splice(editedIndex, 1);
          }
        }
      },
      // 获取有无收费项目函数
      async getHasMoney() {
        // 判断是否开启了任何付费项目
        let isOpen = false;
        this.tableData.forEach(item => {
          if (item.enabled == "1") {
            // 如果开启了开关，检查是否有收费项
            if (item.phone == "1" || (item.emailMoney && item.email == "1")) {
              isOpen = true;
            }
          }
        });
        // 没收费项
        if (!isOpen) return true;
        // 判断有无零钱
        let localuserid = localStorage.getItem("uId");
        let obj = {
          userId: localuserid
        };
        let res = await this.$api.request(this.$url.myWallet.wallet, this.$method.get, obj);
        if (res.code === 0) {
          if (+res.data.userWallet > 0) {
            return true;
          }
          return false;
        } else {
          this.$message.warning(this.$t("system.cztk"));
          this.loading = false;
        }
      },
      handlerCloseWallet() {
        this.dialogToWallet = false;
        this.loading = false;
        console.log(this.loading);
      },
      handlerChangeToWallet() {
        clearInterval();
        this.$router.push("/mywallet/topup");
      },
      // 保存单条
      async handlerSaveSingle(row, index) {
        let that = this;

        // 检查是否有收费项且余额不足
        let needCheck = false;
        if (row.enabled == "1") {
          if (row.phone == "1" || (row.emailMoney && row.email == "1")) {
            needCheck = true;
          }
        }

        if (needCheck) {
          let hasMoney = await this.getHasMoney();
          if (!hasMoney) {
            this.dialogToWallet = true;
            that.walletTime = 3;
            let timer = setInterval(() => {
              if (!that.dialogToWallet) {
                clearInterval(timer);
                return;
              }
              that.walletTime = that.walletTime - 1;
              if (that.walletTime == 0) {
                clearInterval(timer);
                that.$router.push("/mywallet/topup");
              }
            }, 1000);
            return;
          }
        }

        // 构造保存数据 - 将带样式的变量映射回 key
        let emailTextToSave = row.emailText;
        let phoneTextToSave = row.phoneText;

        if (row.variable && Array.isArray(row.variable)) {
          emailTextToSave = that.mapVariableToSave(row.emailText, row.variable);
          phoneTextToSave = that.mapVariableToSave(row.phoneText, row.variable);
        }

        let saveData = {
          key: row.key,
          enabled: row.enabled,
          repair: row.repair,
          self: row.self,
          email: row.email,
          phone: row.phone,
          emailTitle: row.emailTitle,
          emailText: emailTextToSave,
          phoneText: phoneTextToSave
        };

        console.log(this.$t("system.Config.978205-12"), saveData);

        that.loading = true;
        let url = that.$url.NewNotice.update;
        let method = that.$method.put;
        that.$api
          .request(url, method, saveData)
          .then(res => {
            that.loading = false;
            if (res.code === 0) {
              that.$message.success(res.msg);
              // 保存成功后更新备份
              that.copyData[index] = JSON.parse(JSON.stringify(row));
              // 从已编辑列表中移除
              const editedIndex = that.editedRows.indexOf(row.key);
              if (editedIndex > -1) {
                that.editedRows.splice(editedIndex, 1);
              }
            } else {
              that.$message.warning(res.msg);
            }
          })
          .catch(err => {
            that.loading = false;
            that.$message.error(err.msg || this.$t("system.Config.978205-13"));
          });
      },
      // 重置单条
      handlerResetSingle(index) {
        const row = this.tableData[index];
        // 使用 $set 确保数组项替换触发视图更新
        const restored = JSON.parse(JSON.stringify(this.copyData[index]));
        this.$set(this.tableData, index, restored);
        // 从已编辑列表中移除
        const editedIndex = this.editedRows.indexOf(row.key);
        if (editedIndex > -1) {
          this.editedRows.splice(editedIndex, 1);
        }
        // 强制刷新一次，确保 el-table 的行样式与单元格渲染同步
        this.$nextTick(() => this.$forceUpdate());
        this.$message.success(this.$t("system.resetSucess"));
      },
      // 富文本编辑器失焦事件 - 记录光标位置
      handlerBlur() {
        // 记录当前的光标位置信息，用于插入变量
        const selection = window.getSelection();
        if (selection.rangeCount > 0) {
          const range = selection.getRangeAt(0);
          this.range.end = range.endOffset;
          this.range.endText = range.endContainer.textContent;
        }
      },
      // 插入变量到富文本编辑器
      handlerAddToPoint(key, value) {
        const variableText = `【${value}】`;

        // 如果没有内容，直接设置
        if (!this.nowRow.emailText) {
          this.nowRow.emailText = variableText;
          return;
        }

        // 如果没有记录光标位置，追加到开头
        if (this.range.endText === null || this.range.endText === "") {
          this.nowRow.emailText = variableText + this.nowRow.emailText;
          return;
        }

        // 在记录的光标位置插入
        let startIndex = this.nowRow.emailText.indexOf(this.range.endText) + this.range.end;
        let textarr = this.nowRow.emailText.split("");
        textarr.splice(startIndex, 0, variableText);
        this.nowRow.emailText = textarr.join("");
      },
      // 将变量key映射为带样式的value（用于显示）
      mapVariableToDisplay(text, variables) {
        if (!text || !variables || !Array.isArray(variables)) return text;
        let result = text;
        variables.forEach(item => {
          const regex = new RegExp(item.key.replace(/[{}]/g, "\\$&"), "g");
          // 显示为【变量名】的纯文本占位，确保整体性不被富文本拆分
          result = result.replace(regex, `【${item.value}】`);
        });
        return result;
      },
      // 将带样式的value映射回key（用于保存）
      mapVariableToSave(text, variables) {
        if (!text || !variables || !Array.isArray(variables)) return text;
        let result = text;
        // 将【变量名】映射回 {key}
        variables.forEach(item => {
          const valueEsc = item.value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
          const reg = new RegExp(`【${valueEsc}】`, "g");
          result = result.replace(reg, item.key);
        });

        // 合并多余换行与空白
        result = result.replace(/\n\s*\n/g, "\n").trim();

        // 检测是否包含表格，如果有表格则添加样式
        result = this.addTableStyleIfNeeded(result);

        return result;
      },
      // 为表格内容添加样式
      addTableStyleIfNeeded(content) {
        if (!content) return content;

        // 检测内容中是否包含 table 标签
        const hasTable = /<table/i.test(content);

        if (!hasTable) {
          return content;
        }

        // 表格样式
        const tableStyle =
          "<style>table{border-spacing: 2px;border-collapse: collapse;}th,td{border:2px solid #ebeef5;padding:8px 12px;}</style>";

        // 检查是否已经包含这个样式，避免重复添加
        if (content.includes(tableStyle)) {
          return content;
        }

        // 在内容开头添加样式
        return tableStyle + content;
      },
      // 获取通知配置列表
      handlerGetInfo() {
        let _self = this;
        _self.loading = true;
        let url = _self.$url.NewNotice.list;
        let method = _self.$method.get;
        _self.$api
          .request(url, method, {})
          .then(res => {
            if (res.code === 0) {
              _self.loading = false;
              // 处理数据：将变量key映射为带样式的value
              let data = res.data || [];
              data.forEach(item => {
                if (item.variable && Array.isArray(item.variable)) {
                  // 映射邮件内容
                  if (item.emailText) {
                    item.emailText = _self.mapVariableToDisplay(item.emailText, item.variable);
                  }
                  // 映射短信内容
                  if (item.phoneText) {
                    item.phoneText = _self.mapVariableToDisplay(item.phoneText, item.variable);
                  }
                }
              });
              _self.tableData = data;
              // 复制一份用于重置
              _self.copyData = JSON.parse(JSON.stringify(_self.tableData));
            }
          })
          .catch(err => {
            _self.loading = false;
            _self.$notify({
              title: _self.$t("common.tip"),
              message: err.msg,
              type: "error"
            });
          });
        // 获取短信费用
        let urls = _self.$url.Promote.getDictValue;
        let methods = _self.$method.get;
        _self.$api
          .request(urls, methods, {
            dictType: "service_type_amount",
            dictLabel: "WALLET_SMS"
          })
          .then(res => {
            console.log(res, 555);
            if (res.code === 0) {
              this.smsprice = parseFloat(res.data);
            }
          })
          .catch(err => {
            _self.$notify({
              title: _self.$t("common.tip"),
              message: err.msg,
              type: "error"
            });
          });
      },
      // 编辑短信/邮件
      handlerExitOne(row) {
        console.log(row, 111);
        // 深拷贝当前行数据，避免直接修改原数据
        this.nowRow = JSON.parse(JSON.stringify(row));
        this.editingRowKey = row.key; // 记录正在编辑的行的 key
        this.exitDialogVisible = true;
      },
      // 编辑对话框保存（只更新本地数据）
      handlerSaveEdit() {
        // 找到对应的行并更新
        let index = this.tableData.findIndex(item => item.key === this.editingRowKey);
        if (index !== -1) {
          // 使用 $set 确保响应式更新
          // 保留原有的其他字段，只更新编辑的字段
          Object.assign(this.tableData[index], {
            self: this.nowRow.self,
            repair: this.nowRow.repair,
            emailTitle: this.nowRow.emailTitle,
            emailText: this.nowRow.emailText,
            phoneText: this.nowRow.phoneText
          });

          // 标记该行已编辑但未保存
          if (!this.editedRows.includes(this.editingRowKey)) {
            this.editedRows.push(this.editingRowKey);
          }

          // 强制更新视图
          this.$forceUpdate();

          this.$message({
            message: this.$t("system.Config.978205-14"),
            type: "success",
            duration: 3000,
            showClose: true
          });
        }
        this.exitDialogVisible = false;
      },
      // 查看tips
      handlerLookTips(n, content) {
        n == 1
          ? (this.lookTips.title = this.$t("system.Config.315724-1"))
          : (this.lookTips.title = this.$t("system.Config.315724-2"));

        // 短信内容(n==1)需要去除HTML标签，只保留纯文本
        if (n == 1) {
          // 将HTML标签去掉，只保留文本内容
          let plainText = content.replace(/<[^>]*>/g, "");
          this.lookTips.content = plainText;
        } else {
          // 邮件内容(n==2)保留HTML样式
          this.lookTips.content = content || "";
        }

        this.lookTips.dialogVisible = true;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .add-product {
    ::v-deep .el-dialog__body {
      height: auto;
      padding: 10px 24px;
    }
    ::v-deep .el-form-item__content {
      line-height: 40px;
    }

    // 变量样式 - 不可编辑的变量块
    ::v-deep .variable-tag {
      color: #409eff !important;
      text-decoration: underline !important;
      font-weight: 500 !important;
      padding: 0 2px !important;
      margin: 0 1px !important;
      cursor: pointer !important;
      white-space: nowrap !important;
      display: inline-block !important;
      user-select: none !important;
    }
  }
  .el-form-item {
    margin-bottom: 0;
  }
  .ca {
    color: #aaa;
  }

  // 编辑对话框底部样式
  ::v-deep .el-dialog__footer {
    .dialog-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  // 已编辑但未保存的行高亮
  ::v-deep .el-table {
    .edited-row {
      background-color: #fdf6ec !important;
    }
    .edited-row:hover > td {
      background-color: #fdf6ec !important;
    }
  }
</style>
